export const Marquee = ({ items }) => {
  const row = [...items, ...items];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden bg-accent border-y border-ink/15 py-5 select-none" aria-hidden="true">
      <div className="marquee-track">
        {row.map((item, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span
              className={`font-display text-4xl md:text-6xl font-semibold uppercase tracking-tight whitespace-nowrap px-8 ${
                i % 2 === 0 ? 'text-outline-ink' : 'text-ink'
              }`}
            >
              {item}
            </span>
            <span className="w-3 h-3 bg-ink shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
};
